import { StateCreator } from 'zustand';

import { Store } from '@/store';

export interface IOrderState {
  orderNums: {
    unpaid: number;
    processing: number;
    shipped: number;
    delivery: number;
    review: number;
    closed: number;
  };
}

export interface OrderActions {
  setOrderNums: (orderNums: IOrderState['orderNums']) => void;
}

export type OrderSlice = IOrderState & OrderActions;

export const initialOrderState: IOrderState = {
  orderNums: {
    unpaid: 0,
    processing: 0,
    shipped: 0,
    delivery: 0,
    review: 0,
    closed: 0,
  },
};

export const createOrderSlice: StateCreator<Store, [], [], OrderSlice> = (set) => ({
  ...initialOrderState,
  setOrderNums: (orderNums: IOrderState['orderNums']) => set({ orderNums }),
});
